import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-freeship',
  templateUrl: './freeship.component.html',
  styleUrls: ['./freeship.component.scss']
})
export class FreeshipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
